import React from 'react'
import { IFilterOption } from './types'
import { Box, Chip } from '@mui/material'
import { isDesktop, isTablet } from 'react-device-detect'
import { ElectricBolt } from '@mui/icons-material'

interface FilterOptionsChipsProps {
    filterOptions: IFilterOption[]
    setFilterOptions?: (filterOptions: IFilterOption[]) => void
}

function FilterOptionsChips({
    filterOptions,
    setFilterOptions
}: FilterOptionsChipsProps) {
  return  <>{filterOptions.map((value, index) => (
    <Box key={index} sx={{ display: 'inline-block' }}>
      <Chip
        label={
          (isDesktop || isTablet)
            ? value.display().replaceAll('_', ' ')
            : value
                .display()
                .split(': ')
                .map((item, index) => (
                  <>
                    {item.replaceAll('_', ' ')}{' '}
                    {index !== value.display().split(': ').length - 1 && (
                      <br />
                    )}
                  </>
                ))
        }
        icon={value.isQuickFilter() ? <ElectricBolt /> : undefined}
        disabled={value.isFrozen()}
        onDelete={setFilterOptions && (() =>
           setFilterOptions(filterOptions.filter((_, i) => index !== i))
        )}
        sx={{
          backgroundColor: '#e0e0e0',
          margin: 0.1,
        }}
      />
    </Box>
  ))}
  </>
}

export { FilterOptionsChips }